Auth = require 'db/auth'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
track = require 'debug/track'
activityFeedFilterTemplate = require 'views/templates/activity_feed_filter'

module.exports = class BoardsPageActivityFeedInfoView extends View
  viewTitleKey: 'activity feed filter'
  tagName: 'div'
  className: 'activity-feed-filter-menu'

  events:
    'click .js-filter-click li': 'applyFilter'

  render: ->
    @$el.html activityFeedFilterTemplate
      organizationList: @options.organizationList
      currentFilter: @options.currentFilter
    @

  applyFilter: (e) ->
    Util.stop(e)
    track('Boards View', 'Activity Feed', 'Clicked filter item')
    filterVal = e.currentTarget.attributes['data-filterId'].value
    @options.filterActivityFeed(filterVal)
    return



// WEBPACK FOOTER //
// ./app/scripts/views/member/boards-page-activity-feed-filter-view.coffee